import NearMeIcon from '@mui/icons-material/NearMe';
import { Box, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  actions as appActions,
  selectors as appSelectors,
} from 'redux/app/app.slice';
import SearchBoxAutocomplete from '../search-box-autocomplete/search-box-autocomplete.component';

const name = 'pickupSearch';
const PickupLocationsSearch = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchByGeoLocation, setSearchByGeoLocation] = useState(false);
  const searchLocation = useSelector(appSelectors.selectSearchLocation);
  const [showError, setShowError] = useState();

  const handleChange = value => {
    setSearchByGeoLocation(false);
    setShowError(false);
    dispatch(appActions.setSearchLocation(value));
    dispatch(appActions.setGeoLocation(undefined));
  };

  const successCallback = position => {
    const location = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };
    setSearchByGeoLocation(true);
    dispatch(appActions.setGeoLocation(location));
    dispatch(appActions.setSearchLocation(undefined));
  };

  const errorCallback = error => {
    if (error.code === 1)
      toast.error(
        t('locations.pickupInput.locationSearch.geoLocationErrors.permission'),
      );
    else
      toast.error(
        t('locations.pickupInput.locationSearch.geoLocationErrors.failure'),
      );
    dispatch(appActions.setGeoLocation(undefined));
  };

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  };

  const handleAddressSubmit = e => {
    e.preventDefault();
    setShowError(!searchLocation);
  };

  const handleUseCurrentLocation = () => {
    getCurrentLocation();
    dispatch(appActions.setSearchLocation(null));
    setShowError(false);
  };

  return (
    <Box>
      <form onSubmit={handleAddressSubmit}>
        <SearchBoxAutocomplete
          name={name}
          defaultValue={searchLocation}
          value={searchLocation}
          onChange={handleChange}
          autocompleteInputProps={{
            placeholder: t('locations.pickupInput.locationSearch.placeholder'),
          }}
          autocompleteProps={{
            forcePopupIcon: false,
            ListboxProps: {
              'data-testid': 'AddressSelect.CustomSelect.Menu',
            },
            'data-testid': 'AddressSelect.CustomSelect',
          }}
          formErrorProps={
            showError
              ? {
                  errorMessage: t('locations.pickupInput.locationSearch.error'),
                  'aria-label': t('addressSelect.aria.instructions'),
                }
              : {}
          }
        />
      </form>
      <Link
        disabled={searchByGeoLocation}
        component="button"
        type="button"
        onClick={handleUseCurrentLocation}
        sx={{ display: 'inline-flex', mt: 1 }}
        color="textPrimary"
        data-testid="PickupLocationSearch.CurrentLocation"
      >
        <Typography>
          {t('locations.pickupInput.currentLocation.text')}
        </Typography>
        <NearMeIcon sx={{ ml: 0.5 }} />
      </Link>
    </Box>
  );
};

export default PickupLocationsSearch;
